import { PropTypes } from "react";
import TextareaAutosize from "react-textarea-autosize";
import GrComponentFactory from "../gr_component_factory";
import classnames from "classnames";
import keys from "../../modules/keys";
import { isEmpty } from "lodash";

/*
 A form that displays with z-index: $z-index-long-text-popup-form that has a header, a single large
 textarea with a live character count, and save and cancel buttons.

 Also contains optional social links, which currently consists of a Facebook toggle.
 Enable these by passing a showSocialLinks=true prop (false by default).
 */
export default GrComponentFactory.createClass({
  displayName: "LongTextPopupForm",
  propTypes: {
    characterLimit: PropTypes.number.isRequired,
    text: PropTypes.string,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onTextChange: PropTypes.func.isRequired,
    submitButtonLabel: PropTypes.string,
    header: PropTypes.element.isRequired,

    // Set to true while waiting for the server to respond with success or failure
    saveInProgress: PropTypes.bool,

    // include { required: true } inside textareaProps to validate the presence of text
    // all other props are passed along unchanged to TextareaAutosize
    textareaProps: PropTypes.object,
  },

  getDefaultProps() {
    return {
      submitButtonLabel: "Save",
      submitButtonDisabled: false,
      submissionInProgress: false,
      text: "",
    };
  },

  submit() {
    this.props.onSubmit(this.props.text);
  },

  cancel() {
    this.props.onCancel();
  },

  handleClickOutside() {
    this.cancel();
  },

  remainingCharacterCount() {
    return this.props.characterLimit - this.props.text.length;
  },

  tooManyCharacters() {
    return this.remainingCharacterCount() < 0;
  },

  tooFewCharacters() {
    if (this.props.textareaProps && this.props.textareaProps.required) {
      return isEmpty(this.props.text);
    }
    return false;
  },

  isValid() {
    return !this.tooManyCharacters() && !this.tooFewCharacters();
  },

  saveInProgress() {
    return this.props.saveInProgress;
  },

  isSubmitButtonDisabled() {
    return !this.isValid() || this.saveInProgress();
  },

  updateTextChanged(value) {
    if (this.props.onTextChange) {
      this.props.onTextChange(value);
    }
    this.setState({ text: value,
                    remainingCharacterCount: this.props.characterLimit - value.length });
  },

  hideOnEscape(ev) {
    if (keys.isDefaultCloserKey(ev.keyCode)) {
      this.cancel();
    }
  },

  submitButtonLabel() {
    if (this.saveInProgress()) {
      return "Saving...";
    } else {
      return this.props.submitButtonLabel;
    }
  },

  renderFooter() {
    const charCountClasses = classnames(
      "longTextPopupForm__remainingCharacterCount",
      { "longTextPopupForm__remainingCharacterCount--tooHigh": this.tooManyCharacters() }
    );
    return <div className="longTextPopupForm__footer">
      <span className={charCountClasses}>
        {this.remainingCharacterCount()} characters left
      </span>
      <button className="gr-buttonAsLink" onClick={this.cancel}>
        Cancel
      </button>
      <button className="gr-button longTextPopupForm__submitButton"
        onClick={this.submit}
        disabled={this.isSubmitButtonDisabled()}>
        {this.submitButtonLabel()}
      </button>
    </div>;
  },

  render() {
    return <div className="longTextPopupForm" onKeyDown={this.hideOnEscape}>
      <div className="longTextPopupForm__header u-beigeBackground">
        {this.props.header}
      </div>
      <TextareaAutosize className="gr-textarea longTextPopupForm__textInput"
        onChange={(ev) => { this.props.onTextChange(ev.target.value);}}
        value={this.props.text}
        {...this.props.textareaProps}
      />
      {this.renderFooter()}
    </div>;
  },
});
